import { render, staticRenderFns } from "./additional-info.vue?vue&type=template&id=088fd2de&"
import script from "./additional-info.vue?vue&type=script&lang=js&"
export * from "./additional-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports